import { Card, CardContent } from '@ui/card.tsx';
import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUser } from '@r/api/auth.tsx';
import { UpdateCompanyClientForm } from '@r/components/company/update-company-client-form.tsx';
import type { CompanyCompanyReadModel } from '@r/api/generated/client.schemas.ts';

export const CompanyInformations = () => {
  const { t } = useTranslation();
  const user = useUser().data;
  const rawCompany = user?.visibleWorkspaces?.[0]?.company;
  const company = (rawCompany as CompanyCompanyReadModel) ?? null;

  return (
    <div className="overflow-x-hidden flex-grow">
      <div className="pl-8 flex flex-col h-full text-foreground">
        <div className="mb-10">
          <div className="flex flex-nowrap items-center mb-3">
            <Settings className="mr-3" />

            <h1 className="flex items-center font-bold text-2xl md:text-3xl lg:text-[2.75rem] lg:leading-[3.5rem]">
              {t('account.company.title')}
            </h1>
          </div>

          <p className="font-light text-muted-foreground">{t('account.company.description')}</p>
        </div>

        <Card className="w-full border-0">
          <CardContent className="p-7">
            {company ? (
              <UpdateCompanyClientForm company={company} />
            ) : (
              <div className="py-8 text-center text-muted-foreground">
                {t('personal.information.company.not.found')}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
